<template>
  <vs-button
    class="w-full mt-2"
    @click="copy"
    size="small"
  >
    Duplicate English to Chinese
  </vs-button>
</template>

<script>
export default {
  methods: {
    copy() {
      return this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm copy and overwrite?',
        text: 'Copying will overwrite all existing content in Chinese form. Do you want to continue?',
        acceptText: 'Yes. Copy and overwrite.',
        accept: () => {
          const id = this.zhForm.id;
          const languageCode = this.zhForm.languageCode;
          const copiedForm = JSON.parse(JSON.stringify(this.enForm));

          copiedForm.id = id;
          copiedForm.languageCode = languageCode;

          this.formZhForm = copiedForm;
        },
      });
    }
  },
  computed: {
    formZhForm: {
      get() {
        return this.zhForm;
      },
      set(value) {
        this.$emit('update:zhForm', value);
      },
    }
  },
  props: {
    enForm: {
      type: Object,
      required: true,
    },
    zhForm: {
      type: Object,
      required: true
    },
  }
};
</script>
